<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  //监听器
  watch: {

  },
}
</script>

<style>
#app,body{
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue